export const GRID_CONSTANTS = {
	minWidth: 100,
	maxWidth: 400,
	minGap: 15
};
